export default __webpack_public_path__ + "static/media/Christmas_04.36ba4234.png";